var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"v-header"}},[_c('img',{attrs:{"src":require("@/assets/aws-summit-logo.png"),"alt":"AWS SUMMIT TAIPEI","width":"150"}})])}]

export { render, staticRenderFns }